import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react'
import { useRouter } from 'next/router'
import { PropsWithChildren, useEffect } from 'react'
import useUser from 'shared/hooks/use-user'

export const growthbookClient = new GrowthBook({
  clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: process.env.NODE_ENV === 'development',
})

export function GrowthbookClientProvider({ children }: PropsWithChildren) {
  const router = useRouter()
  const { user } = useUser()

  useEffect(() => {
    function updateGrowthBookURL() {
      growthbookClient.setURL(window.location.href)
    }

    growthbookClient.init({
      skipCache: true,
      streaming: true,
    })

    router.events.on('routeChangeComplete', updateGrowthBookURL)
    return () => router.events.off('routeChangeComplete', updateGrowthBookURL)
  }, [])

  useEffect(() => {
    if (!user) return
    growthbookClient.setAttributes({
      id: user.id,
      roles: user.roles,
      userPlanId: user.userPlanId,
      country: user.country,
    })
  }, [user])

  return <GrowthBookProvider growthbook={growthbookClient}>{children}</GrowthBookProvider>
}
